import { SyncFn } from './sync-coordinator';
import {
  getStationSyncPosition,
  isStationOrientationMeaningful,
} from './source-positions';
import { applyToMap } from './apply-to-map';

/**
 * Syncs from a station/image source pane to a map (top-down) target pane.
 * Centers the map camera on the station position when not visible and
 * propagates source quaternion + fov to the target frustum only when the
 * source orientation is meaningful (i.e. not Planar).
 */
export const syncStationToMap: SyncFn = async (source, target) => {
  const syncPosition = getStationSyncPosition(source)?.position;
  if (!syncPosition) return;

  const sourceViewer = source.viewerWrapper()?.viewer;
  const targetViewer = target.viewerWrapper()?.viewer;
  if (!sourceViewer || !targetViewer) return;

  applyToMap(
    target,
    targetViewer,
    sourceViewer,
    syncPosition,
    isStationOrientationMeaningful(source)
  );
};
